// extracted by mini-css-extract-plugin
module.exports = {"ttsFont":"TextToSpeech_ttsFont__3ykWc","ttsRow":"TextToSpeech_ttsRow__1p3-h","ttsSource":"TextToSpeech_ttsSource__YwB4K","ttsSettings":"TextToSpeech_ttsSettings__OIX63"};